export const styles = theme => ({
  blockUi: {
    height: '99vh',
    padding: '3em',
    '& .block-ui-overlay': {
      backgroundColor: 'transparent'
    }
  }
});